// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import { FullPageGrid } from "../FullPageGrid";
import { ErrorTitle } from "./ErrorTitle";
import { ErrorCode } from "./ErrorCode";
import { ErrorDescription } from "./ErrorDescription";
import { useIsRTL, useLocMessage } from "../../../store/localization/hooks";
import { ErrorIcon } from "./ErrorIcon";
import { Box, Button, Grid } from "@material-ui/core";

export interface IErrorPageProps {
  errorCode: string;
  onDismiss: () => void;
}

export function ErrorPage({
  errorCode,
  onDismiss,
}: IErrorPageProps): JSX.Element {
  const dismissMessage = useLocMessage("dismiss", "Cancel");
  const isRTL = useIsRTL();

  return (
    <FullPageGrid
      container
      direction="row"
      justify="center"
      alignItems="center"
    >
      <ErrorIcon />

      <Grid item>
        <ErrorTitle errorCode={errorCode} />
        <ErrorDescription errorCode={errorCode} />
        <Box
          width="345px"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginTop="-5px"
        >
          {/* Need this box in RTL mode to set the error code at the center, while button will remain at the right corner*/}
          {isRTL && <Box />}

          <ErrorCode errorCode={errorCode} />

          <Button
            color="primary"
            size="small"
            variant="contained"
            onClick={onDismiss}
          >
            {dismissMessage}
          </Button>
        </Box>
      </Grid>
    </FullPageGrid>
  );
}
